/**
 * DELETE /auth/personal-tokens/revoke-token/:id - Revoke a personal access token (row action)
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const revokeTokenAction: ActionDefinition = {
  key: 'revoke-token',
  label: { en: 'Revoke Token', es: 'Revocar token' },
  icon: 'mdi:key-remove',
  scope: 'row',
  method: 'DELETE',
  select: ['id', 'name'],
  casl: { action: 'delete', subject: 'AuthPersonalToken' },
  confirm: {
    type: 'simple',
    message: {
      en: 'This token will be permanently revoked. Any applications using it will lose access.',
      es: 'Este token será revocado permanentemente. Las aplicaciones que lo usen perderán acceso.'
    },
    severity: 'warning'
  },
  middleware: (ctx) => ctx.core.middleware['auth'] as MiddlewareHandler,
  handler: async (ctx, input, c) => {
    const { _record, _authUserId } = input as { _record: { id: string }; _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const authService = ctx.services.get<AuthService>('auth')

    const revoked = await authService.revokePersonalToken(
      _authUserId,
      _record.id,
      getRequestInfo(c)
    )

    if (!revoked) {
      throw new ctx.core.errors.NotFoundError('Token')
    }

    return { success: true }
  }
}
